import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ShieldAlert, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/constants";

export const BlockingAlert = () => {
  const queryClient = useQueryClient();
  const { data: blocks = [] } = useQuery({
    queryKey: ["blocks"],
    queryFn: () => api.get("/alerts/blocks").then((r) => r.data),
    refetchInterval: 10000,
  });

  const dismiss = async (source) => {
    await api.delete(`/alerts/blocks/${source}`);
    queryClient.invalidateQueries({ queryKey: ["blocks"] });
  };

  if (!blocks.length) return null;

  return (
    <div data-testid="blocking-alert" role="alert" className="fade-up mb-8 rounded-lg border-2 border-[#FF3B30] bg-red-50 p-5">
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 animate-pulse text-[#FF3B30]" />
        <div className="min-w-0 flex-1">
          <div className="font-display text-lg font-bold text-[#FF3B30]">Blocage détecté par une source</div>
          <ul className="mt-2 space-y-2 text-sm text-zinc-800">
            {blocks.map((b) => (
              <li key={b.source} data-testid={`blocking-alert-${b.source}`} className="flex items-start justify-between gap-3">
                <span>
                  <span className="font-semibold">{b.label}</span> — {b.message}
                  <span className="ml-2 font-mono text-[11px] text-muted-foreground">{formatDate(b.last_seen)}</span>
                </span>
                <button data-testid={`blocking-alert-dismiss-${b.source}`} onClick={() => dismiss(b.source)} title="Masquer" className="shrink-0 text-zinc-400 hover:text-zinc-900">
                  <X className="h-4 w-4" />
                </button>
              </li>
            ))}
          </ul>
          <Button asChild size="sm" className="mt-4 bg-[#FF3B30] hover:bg-[#e0352b]" data-testid="blocking-alert-proxy-link">
            <Link to="/parametres#proxies">Configurer les proxies</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
